export const directoryEn = {
  directory: {
    export: {
      title: 'Email address export',
      subtitle: 'Filter people and copy their addresses to paste into your mail client',
      accessDenied: 'You do not hold an organizational role that grants access to address export.',
      filters: 'Filters',
      region: 'Region',
      role: 'Role / service',
      group: 'Group',
      noOptions: 'No options',
      search: 'Search',
      results: 'Results',
      resultCount: '{count} addresses',
      empty: 'No results — apply filters or add manually',
      addPerson: 'Add person',
      addEmail: 'Add any email',
      personHasNoEmail: 'This person has no email address',
      invalidEmail: 'Invalid email address',
      copyPlain: 'Copy addresses only',
      copyLabeled: 'Copy with labels',
      copied: 'Copied to clipboard',
    },
    persons: {
      title: 'People browser',
      subtitle: 'Browse, edit, and merge duplicate people within your scope',
      accessDenied: 'You do not hold an organizational role that grants access to the people browser.',
      searchPlaceholder: 'Search by first name, last name, email, phone...',
      empty: 'No people',
      editTitle: 'Edit person',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      updated: 'Changes saved',
      groupBadge: 'Group: {name}',
      mergeLabel: 'Merge with another person (duplicate)',
      mergeButton: 'Merge',
      mergeConfirm: 'Merge {duplicate} into {keep}? This cannot be undone: all service assignments and group memberships will be moved over, and {duplicate} will be deleted.',
      merged: 'People merged',
    },
  },
}
